import { Pipe, PipeTransform } from '@angular/core';
import { defaultDateFormatOptions } from '@config';
import { DateTime } from 'luxon';

@Pipe({
  name: 'luxonDate',
})
export class LuxonDatePipe implements PipeTransform {
  public transform(dateTime?: DateTime | string, format?: string): string {
    if (!dateTime) {
      return '';
    }

    let value: DateTime;

    if (typeof dateTime === 'string') {
      value = DateTime.fromISO(dateTime);
    } else {
      value = dateTime;
    }

    if (!format) {
      return value.toLocaleString(defaultDateFormatOptions);
    } else {
      return value.toFormat(format);
    }
  }
}
